[data-variant="message-button"] {
    aspect-ratio: 1;
    border: none;
    border-radius: 100%;
    padding: 0;
    background: transparent;
    color: var(--mantine-color-gray-text);
    &:hover {
        background: var(--mantine-color-gray-1);
    }
}

a[data-variant="rounded"] {
    border-radius: var(--mantine-radius-md);
    padding: 4px var(--mantine-spacing-xs);
}

a[data-variant="rounded"][data-active="true"] {
    color: initial;
}

[data-variant="system-select"] {
    &.mantine-Select-input {
        font-size: var(--mantine-font-size-md);
        font-weight: 700;
        color: var(--mantine-color-gray-8);
        border: none;
        border-radius: var(--mantine-radius-md);
        user-select: none;
        /* background: var(--mantine-color-gray-0); */
    }
    & .mantine-Select-dropdown {
        border-radius: var(--mantine-radius-md);
    }
    & .mantine-Select-option {
        border-radius: var(--mantine-radius-md);
    }
}

.input {
    font-size: var(--mantine-font-size-md);
    font-weight: 700;
    color: var(--mantine-color-gray-8);
    border: none;
    border-radius: var(--mantine-radius-md);
    user-select: none;
    /* background: var(--mantine-color-gray-0); */
}

.input:hover {
    background-color: var(--mantine-color-gray-2);
}

.dropdown {
    border-radius: var(--mantine-radius-md);
}

.option {
    border-radius: var(--mantine-radius-md);
}
